module.exports = __webpack_public_path__ + "img/rep-carissa.da3e613b.png";